import React from "react";

export function useToast() {
  const [state, setState] = React.useState({ message: "", visible: false });
  const timerRef = React.useRef(null);

  const showToast = React.useCallback((message, durationMs = 3000) => {
    clearTimeout(timerRef.current);
    setState({ message, visible: true });
    timerRef.current = setTimeout(() => {
      setState((s) => ({ ...s, visible: false }));
    }, durationMs);
  }, []);

  const dismissToast = React.useCallback(() => {
    clearTimeout(timerRef.current);
    setState((s) => ({ ...s, visible: false }));
  }, []);

  React.useEffect(() => () => clearTimeout(timerRef.current), []);

  return {
    toastMessage: state.message,
    toastVisible: state.visible,
    showToast,
    dismissToast
  };
}
